export type NavItem = {
  label: string;
  to: string;
};

export const navItems: NavItem[] = [
  { label: "首页", to: "/" },
  { label: "偶像塌房", to: "/category/idol-meltdown" },
  { label: "演员绯闻", to: "/category/actor-rumors" },
  { label: "歌手翻车", to: "/category/singer-flops" },
  { label: "综艺名场面", to: "/category/variety-moments" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export const primaryNav: NavItem[] = navItems.filter((item) => item.to.startsWith("/category"));

export const secondaryNav: NavItem[] = [
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];